import { images } from '../constants';

const products = [
    {
        id: 1,
        image: images.product1Gallery1,
        name: "Smart TV",
        price: 50,
        disprice: 40,
        stock: 10,
        content: "Experience next-level entertainment with our high-definition Smart TV. Equipped with built-in streaming apps, voice control, and seamless connectivity, it transforms any room into a home theater.",
        description: "Our Smart TV delivers crystal-clear visuals, dynamic sound, and intuitive functionality. With multiple HDMI ports, Wi-Fi capability, and support for popular streaming services, it’s perfect for binge-watching, gaming, and more. Sleek, modern, and energy-efficient — it's a centerpiece for any modern living space.",
        category: ["Smart Devices", "Home Entertainment"],
        tags: ["smart", "streaming", "audio"],
        gallery: {
            image1: images.product1Gallery1,
            image2: images.product1Gallery2,
            image3: images.product1Gallery3,
            image4: images.product1Gallery4,
        },
        addInfo: [
            { id: 1, title: "Screen Size", content: "55 inches" },
            { id: 2, title: "Resolution", content: "4K Ultra HD" },
            { id: 3, title: "Connectivity", content: "Wi-Fi, HDMI, USB" },
            { id: 4, title: "Smart Features", content: "Built-in Apps, Voice Control" }
        ],
        comments: [
            {
                id: 1,
                image: images.product1Review1,
                name: "Emma Thompson",
                date: "Mar 02, 2025",
                rating: 5,
                content: "Crisp display and fast interface. Love the voice control feature — makes browsing so easy!"
            },
            {
                id: 2,
                image: images.product1Review2,
                name: "Liam Walker",
                date: "Mar 10, 2025",
                rating: 4.5,
                content: "Excellent quality and easy setup. It's a great addition to our family room."
            }
        ]
    },
    {
        id: 2,
        image: images.product2Gallery1,
        name: "Remote Control",
        price: 50,
        disprice: 40,
        stock: 8,
        content: "Control your entertainment with ease using our ergonomic Remote Control. Designed for compatibility with multiple devices, it's responsive, reliable, and comfortable to use all day long.",
        description: "Our Remote Control features intuitive navigation, responsive buttons, and wide-range signal coverage. Whether you're switching channels or adjusting volume, it offers seamless performance. Compatible with most Smart TVs, set-top boxes, and media players. Lightweight and durable, it’s the perfect replacement or upgrade.",
        category: ["Tech Accessories", "Home Entertainment"],
        tags: ["remote", "smart", "usb"],
        gallery: {
            image1: images.product2Gallery1,
            image2: images.product2Gallery2,
            image3: images.product2Gallery3,
            image4: images.product2Gallery4,
        },
        addInfo: [
            { id: 1, title: "Compatibility", content: "Smart TVs, Set-Top Boxes" },
            { id: 2, title: "Battery Type", content: "2 x AAA (not included)" },
            { id: 3, title: "Range", content: "Up to 10 meters" },
            { id: 4, title: "Material", content: "ABS Plastic" }
        ],
        comments: [
            {
                id: 1,
                image: images.product2Review1,
                name: "Sophia Martinez",
                date: "Mar 18, 2025",
                rating: 5,
                content: "Works perfectly with my Smart TV. Buttons are soft and responsive!"
            },
            {
                id: 2,
                image: images.product2Review2,
                name: "Jackson Lee",
                date: "Mar 21, 2025",
                rating: 4.5,
                content: "Nice quality and quick pairing. A solid remote at a great price."
            }
        ]
    },
    {
        id: 3,
        image: images.product3Gallery1,
        name: "Webcam Camera",
        price: 50,
        disprice: 40,
        stock: 5,
        content: "Stay connected with crystal-clear video using our high-definition Webcam Camera. Perfect for video calls, online classes, and streaming, it delivers smooth performance and sharp image quality.",
        description: "Our Webcam Camera offers 1080p HD resolution with auto light correction and a built-in noise-reducing microphone for clear conversations. It easily mounts on laptops, monitors, or tripods, and connects via USB for quick setup. Ideal for professionals, gamers, and students alike.",
        category: ["Office Equipment", "Tech Accessories"],
        tags: ["camera", "usb", "smart"],
        gallery: {
            image1: images.product3Gallery1,
            image2: images.product3Gallery2,
            image3: images.product3Gallery3,
            image4: images.product3Gallery4,
        },
        addInfo: [
            { id: 1, title: "Resolution", content: "1080p Full HD" },
            { id: 2, title: "Microphone", content: "Built-in Noise Reduction" },
            { id: 3, title: "Connection", content: "USB 2.0" },
            { id: 4, title: "Mounting Options", content: "Clip & Tripod Compatible" }
        ],
        comments: [
            {
                id: 1,
                image: images.product3Review1,
                name: "Liam Anderson",
                date: "Apr 02, 2025",
                rating: 5,
                content: "Crystal clear image and great mic. Easy to set up and perfect for work meetings."
            },
            {
                id: 2,
                image: images.product3Review2,
                name: "Maya Chen",
                date: "Apr 04, 2025",
                rating: 4.5,
                content: "Amazing value for the quality. My Zoom calls have never looked better!"
            }
        ]
    },
    {
        id: 4,
        image: images.product4Gallery1,
        name: "Headset",
        price: 50,
        disprice: 40,
        stock: 0,
        content: "Immerse yourself in rich audio with our high-performance Headset. Designed for comfort and clarity, it’s perfect for gaming, calls, and music on the go or at home.",
        description: "This Headset features crisp stereo sound, an adjustable noise-canceling mic, and soft ear cushions for all-day wear. Compatible with PCs, laptops, and mobile devices via a 3.5mm jack or USB. Whether for work or play, experience top-notch audio performance with stylish comfort.",
        category: ["Office Equipment", "Tech Accessories"],
        tags: ["audio", "headset", "usb"],
        gallery: {
            image1: images.product4Gallery1,
            image2: images.product4Gallery2,
            image3: images.product4Gallery3,
            image4: images.product4Gallery4,
        },
        addInfo: [
            { id: 1, title: "Connection", content: "3.5mm Jack / USB" },
            { id: 2, title: "Microphone", content: "Noise Cancelling" },
            { id: 3, title: "Compatibility", content: "PC, Laptop, Mobile" },
            { id: 4, title: "Cushions", content: "Soft Over-Ear Padding" }
        ],
        comments: [
            {
                id: 1,
                image: images.product4Review1,
                name: "Noah Patel",
                date: "Apr 12, 2025",
                rating: 4.5,
                content: "Excellent sound and super comfy. I use it daily for meetings and gaming sessions."
            },
            {
                id: 2,
                image: images.product4Review2,
                name: "Sophia Wright",
                date: "Apr 15, 2025",
                rating: 5,
                content: "Love the design and sound quality. The mic is great for calls too!"
            }
        ]
    },
    {
        id: 5,
        image: images.product5Gallery1,
        name: "Android Box",
        price: 50,
        disprice: 40,
        stock: 9,
        content: "Turn any TV into a smart entertainment hub with our Android Box. Stream movies, browse apps, and enjoy seamless connectivity in one compact device.",
        description: "The Android Box offers 4K streaming, built-in Wi-Fi, and access to thousands of apps from the Google Play Store. Equipped with HDMI and USB ports, it supports smooth playback, voice control, and screen mirroring. Ideal for upgrading your home entertainment system with ease and flexibility.",
        category: ["Smart Devices", "Streaming Tools"],
        tags: ["android", "streaming", "smart"],
        gallery: {
            image1: images.product5Gallery1,
            image2: images.product5Gallery2,
            image3: images.product5Gallery3,
            image4: images.product5Gallery4,
        },
        addInfo: [
            { id: 1, title: "Resolution", content: "Up to 4K UHD" },
            { id: 2, title: "Connectivity", content: "Wi-Fi, Bluetooth, HDMI" },
            { id: 3, title: "OS", content: "Android TV" },
            { id: 4, title: "Ports", content: "HDMI, USB, AV" }
        ],
        comments: [
            {
                id: 1,
                image: images.product5Review1,
                name: "Lucas Morgan",
                date: "Apr 20, 2025",
                rating: 4,
                content: "Solid performance for streaming apps. Easy to set up and responsive interface."
            },
            {
                id: 2,
                image: images.product5Review2,
                name: "Emma Rivera",
                date: "Apr 22, 2025",
                rating: 5,
                content: "Love the features. Great value for the price, and works flawlessly with my TV."
            }
        ]
    },
    {
        id: 6,
        image: images.product6Gallery1,
        name: "USB Hub",
        price: 50,
        disprice: 40,
        stock: 6,
        content: "Expand your device’s connectivity with our high-speed USB Hub. Ideal for laptops and desktops, it adds multiple ports in seconds.",
        description: "This USB Hub features multiple high-speed USB 3.0 ports for quick data transfers, seamless peripheral connections, and enhanced productivity. With a compact and portable design, it's perfect for office setups, gaming stations, or travel use. Plug-and-play functionality makes it incredibly easy to use.",
        category: ["Tech Accessories", "Office Equipment"],
        tags: ["usb", "smart", "remote"],
        gallery: {
            image1: images.product6Gallery1,
            image2: images.product6Gallery2,
            image3: images.product6Gallery3,
            image4: images.product6Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ports", content: "4 x USB 3.0" },
            { id: 2, title: "Compatibility", content: "Windows, macOS, Linux" },
            { id: 3, title: "Transfer Speed", content: "Up to 5Gbps" },
            { id: 4, title: "Power", content: "Bus-powered" }
        ],
        comments: [
            {
                id: 1,
                image: images.product6Review1,
                name: "Sophie Adams",
                date: "May 03, 2025",
                rating: 4.5,
                content: "Compact and super useful! I use it daily for my work laptop."
            },
            {
                id: 2,
                image: images.product6Review2,
                name: "Liam Chen",
                date: "May 06, 2025",
                rating: 5,
                content: "Transfers are fast and setup is effortless. Perfect for my gaming rig."
            }
        ]
    },
    {
        id: 7,
        image: images.product7Gallery1,
        name: "Set-Top Box",
        price: 50,
        disprice: 40,
        stock: 3,
        content: "Upgrade your TV experience with our HD Set-Top Box. Access cable, satellite, or IPTV with seamless performance and clear visuals.",
        description: "Our Set-Top Box supports full HD streaming and offers advanced features such as digital recording, interactive menus, and parental controls. Compatible with various providers, it brings convenience and clarity to your home entertainment setup. Simple installation and an intuitive remote make it user-friendly for all ages.",
        category: ["Streaming Tools", "Home Entertainment"],
        tags: ["streaming", "android", "smart"],
        gallery: {
            image1: images.product7Gallery1,
            image2: images.product7Gallery2,
            image3: images.product7Gallery3,
            image4: images.product7Gallery4,
        },
        addInfo: [
            { id: 1, title: "Resolution", content: "Full HD 1080p" },
            { id: 2, title: "Connectivity", content: "HDMI, AV Out, USB" },
            { id: 3, title: "Compatibility", content: "Cable, Satellite, IPTV" },
            { id: 4, title: "Remote", content: "Included" }
        ],
        comments: [
            {
                id: 1,
                image: images.product7Review1,
                name: "Grace Morgan",
                date: "May 08, 2025",
                rating: 4.5,
                content: "Great picture quality and easy to set up. Works flawlessly with my cable provider."
            },
            {
                id: 2,
                image: images.product7Review2,
                name: "Ethan Brooks",
                date: "May 10, 2025",
                rating: 4,
                content: "Very responsive and reliable. The UI could be a bit more modern, but it gets the job done well."
            }
        ]
    },
    {
        id: 8,
        image: images.product8Gallery1,
        name: "Desk Phone",
        price: 50,
        disprice: 40,
        stock: 0,
        content: "Reliable and professional, our Desk Phone is perfect for offices and homes needing stable landline communication with modern features.",
        description: "This Desk Phone delivers clear audio, speed dial options, call transfer, and caller ID display. Designed for both home and office environments, it supports hands-free speakerphone mode and easy integration with PBX systems. The ergonomic keypad and LCD screen ensure user-friendly operation.",
        category: ["Office Equipment", "Smart Devices"],
        tags: ["phone", "smart", "usb"],
        gallery: {
            image1: images.product8Gallery1,
            image2: images.product8Gallery2,
            image3: images.product8Gallery3,
            image4: images.product8Gallery4,
        },
        addInfo: [
            { id: 1, title: "Display", content: "LCD with Caller ID" },
            { id: 2, title: "Features", content: "Speakerphone, Speed Dial, Mute" },
            { id: 3, title: "Connectivity", content: "Landline (RJ11)" },
            { id: 4, title: "Compatibility", content: "PBX & Analog Systems" }
        ],
        comments: [
            {
                id: 1,
                image: images.product8Review1,
                name: "Sophia Gray",
                date: "May 12, 2025",
                rating: 4,
                content: "Very dependable desk phone. We use it in our reception and it performs well every day."
            },
            {
                id: 2,
                image: images.product8Review2,
                name: "Liam Harris",
                date: "May 14, 2025",
                rating: 4.5,
                content: "Excellent clarity and functionality. Setup was fast and it feels very solid."
            }
        ]
    },
    {
        id: 9,
        image: images.product9Gallery1,
        name: "Wi-Fi Router",
        price: 50,
        disprice: 40,
        stock: 15,
        content: "Boost your home or office network with our high-speed Wi-Fi Router offering wide coverage and reliable connectivity.",
        description: "Our Wi-Fi Router supports dual-band frequencies, ensuring fast and stable internet connections for multiple devices simultaneously. Featuring advanced security protocols, easy setup, and smart parental controls, it’s ideal for streaming, gaming, and working from home.",
        category: ["Tech Accessories", "Smart Devices"],
        tags: ["router", "smart", "usb"],
        gallery: {
            image1: images.product9Gallery1,
            image2: images.product9Gallery2,
            image3: images.product9Gallery3,
            image4: images.product9Gallery4,
        },
        addInfo: [
            { id: 1, title: "Frequency", content: "Dual Band 2.4GHz & 5GHz" },
            { id: 2, title: "Speed", content: "Up to 1200 Mbps" },
            { id: 3, title: "Security", content: "WPA3 Encryption" },
            { id: 4, title: "Ports", content: "4 x LAN, 1 x WAN" }
        ],
        comments: [
            {
                id: 1,
                image: images.product9Review1,
                name: "Emma Wilson",
                date: "May 15, 2025",
                rating: 5,
                content: "Fast and reliable router, great for multiple devices and heavy usage."
            },
            {
                id: 2,
                image: images.product9Review2,
                name: "Noah King",
                date: "May 17, 2025",
                rating: 4.5,
                content: "Setup was easy and signal strength is excellent throughout my home."
            }
        ]
    },
    {
        id: 10,
        image: images.product10Gallery1,
        name: "Smart Television",
        price: 50,
        disprice: 40,
        stock: 15,
        content: "Experience stunning visuals and seamless streaming with our Smart Television, designed to bring your entertainment to life.",
        description: "This Smart TV features 4K UHD resolution, HDR support, and a built-in app store for all your favorite streaming services. With voice control and multiple HDMI ports, it’s perfect for a modern living room setup.",
        category: ["Smart Devices", "Home Entertainment"],
        tags: ["smart", "streaming", "audio"],
        gallery: {
            image1: images.product10Gallery1,
            image2: images.product10Gallery2,
            image3: images.product10Gallery3,
            image4: images.product10Gallery4,
        },
        addInfo: [
            { id: 1, title: "Resolution", content: "4K UHD" },
            { id: 2, title: "Screen Size", content: "55 inches" },
            { id: 3, title: "Connectivity", content: "Wi-Fi, HDMI, USB" },
            { id: 4, title: "Features", content: "Voice Control, HDR" }
        ],
        comments: [
            {
                id: 1,
                image: images.product10Review1,
                name: "Mia Johnson",
                date: "Mar 10, 2025",
                rating: 5,
                content: "The picture quality is fantastic and the smart features work flawlessly."
            },
            {
                id: 2,
                image: images.product10Review2,
                name: "Ethan Brown",
                date: "Mar 15, 2025",
                rating: 4.5,
                content: "Great TV for streaming and gaming. Easy to set up and use."
            }
        ]
    },
    {
        id: 11,
        image: images.product11Gallery1,
        name: "Wireless Remote",
        price: 40,
        disprice: 30,
        stock: 50,
        content: "Control your devices effortlessly with our ergonomic and responsive Wireless Remote.",
        description: "This Wireless Remote features long battery life, easy pairing, and multi-device compatibility. Ideal for controlling smart TVs, set-top boxes, and other home entertainment devices with precision and convenience.",
        category: ["Tech Accessories", "Home Entertainment"],
        tags: ["remote", "smart", "usb"],
        gallery: {
            image1: images.product11Gallery1,
            image2: images.product11Gallery2,
            image3: images.product11Gallery3,
            image4: images.product11Gallery4,
        },
        addInfo: [
            { id: 1, title: "Battery Life", content: "Up to 12 months" },
            { id: 2, title: "Compatibility", content: "Smart TV, Set-Top Box" },
            { id: 3, title: "Range", content: "10 meters" },
            { id: 4, title: "Connectivity", content: "RF Wireless" }
        ],
        comments: [
            {
                id: 1,
                image: images.product11Review1,
                name: "Sophia Martinez",
                date: "Apr 20, 2025",
                rating: 5,
                content: "Very responsive remote with excellent range and battery life."
            },
            {
                id: 2,
                image: images.product11Review2,
                name: "Liam Davis",
                date: "Apr 22, 2025",
                rating: 4.5,
                content: "Easy to use and pairs quickly with all my devices."
            }
        ]
    },
    {
        id: 12,
        image: images.product12Gallery1,
        name: "Video Webcam",
        price: 50,
        disprice: 40,
        stock: 30,
        content: "Capture crystal-clear video calls and recordings with our high-definition Video Webcam.",
        description: "Featuring full HD resolution, built-in microphone, and easy USB connectivity, this webcam ensures sharp visuals and clear audio for remote work, streaming, and video conferencing. Compatible with most operating systems and video platforms.",
        category: ["Office Equipment", "Tech Accessories"],
        tags: ["camera", "usb", "smart"],
        gallery: {
            image1: images.product12Gallery1,
            image2: images.product12Gallery2,
            image3: images.product12Gallery3,
            image4: images.product12Gallery4,
        },
        addInfo: [
            { id: 1, title: "Resolution", content: "1080p Full HD" },
            { id: 2, title: "Microphone", content: "Built-in Stereo" },
            { id: 3, title: "Connectivity", content: "USB 2.0" },
            { id: 4, title: "Compatibility", content: "Windows, MacOS, Linux" }
        ],
        comments: [
            {
                id: 1,
                image: images.product12Review1,
                name: "Emma Wilson",
                date: "May 02, 2025",
                rating: 4.7,
                content: "Great video quality and very easy to set up for work meetings."
            },
            {
                id: 2,
                image: images.product12Review2,
                name: "Noah Thompson",
                date: "May 05, 2025",
                rating: 4.8,
                content: "Perfect for streaming and clear audio with the built-in mic."
            }
        ]
    },
    {
        id: 13,
        image: images.product13Gallery1,
        name: "Audio Headset",
        price: 50,
        disprice: 40,
        stock: 35,
        content: "Experience immersive sound with our comfortable and high-quality Audio Headset.",
        description: "Designed for crystal-clear audio and noise isolation, this headset is perfect for gaming, calls, and music. Features adjustable headband, soft ear cushions, and a built-in microphone for hands-free communication.",
        category: ["Office Equipment", "Tech Accessories"],
        tags: ["audio", "headset", "usb"],
        gallery: {
            image1: images.product13Gallery1,
            image2: images.product13Gallery2,
            image3: images.product13Gallery3,
            image4: images.product13Gallery4,
        },
        addInfo: [
            { id: 1, title: "Audio Type", content: "Stereo Surround" },
            { id: 2, title: "Microphone", content: "Noise Cancelling" },
            { id: 3, title: "Connectivity", content: "Wired & Wireless" },
            { id: 4, title: "Compatibility", content: "PC, Mac, Consoles" }
        ],
        comments: [
            {
                id: 1,
                image: images.product13Review1,
                name: "Mia Johnson",
                date: "May 10, 2025",
                rating: 4.6,
                content: "Great sound quality and super comfortable to wear for long sessions."
            },
            {
                id: 2,
                image: images.product13Review2,
                name: "Ethan Brown",
                date: "May 12, 2025",
                rating: 4.7,
                content: "Perfect for gaming and calls with excellent noise cancellation."
            }
        ]
    },
    {
        id: 14,
        image: images.product14Gallery1,
        name: "Android Streaming Device",
        price: 50,
        disprice: 40,
        stock: 25,
        content: "Stream your favorite content effortlessly with our Android Streaming Device.",
        description: "Supports 4K Ultra HD streaming, voice control, and access to thousands of apps via the Google Play Store. Easy to set up and compatible with most TVs, it turns any screen into a smart entertainment hub.",
        category: ["Smart Devices", "Streaming Tools"],
        tags: ["android", "streaming", "smart"],
        gallery: {
            image1: images.product14Gallery1,
            image2: images.product14Gallery2,
            image3: images.product14Gallery3,
            image4: images.product14Gallery4,
        },
        addInfo: [
            { id: 1, title: "Resolution", content: "4K Ultra HD" },
            { id: 2, title: "Control", content: "Voice Remote" },
            { id: 3, title: "Apps", content: "Google Play Store Access" },
            { id: 4, title: "Compatibility", content: "Most TVs" }
        ],
        comments: [
            {
                id: 1,
                image: images.product14Review1,
                name: "Sophia Lee",
                date: "Apr 20, 2025",
                rating: 4.8,
                content: "Fantastic streaming experience with easy setup and great app selection."
            },
            {
                id: 2,
                image: images.product14Review2,
                name: "Liam Martinez",
                date: "Apr 22, 2025",
                rating: 4.9,
                content: "Reliable device with excellent picture quality and responsive voice control."
            }
        ]
    },
    {
        id: 15,
        image: images.product15Gallery1,
        name: "USB Expansion Hub",
        price: 50,
        disprice: 40,
        stock: 40,
        content: "Expand your connectivity options with our versatile USB Expansion Hub.",
        description: "Features multiple USB ports for connecting various devices simultaneously. Compact design with fast data transfer rates, compatible with PCs, laptops, and other USB-enabled devices.",
        category: ["Tech Accessories", "Office Equipment"],
        tags: ["usb", "smart", "remote"],
        gallery: {
            image1: images.product15Gallery1,
            image2: images.product15Gallery2,
            image3: images.product15Gallery3,
            image4: images.product15Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ports", content: "7 USB 3.0 Ports" },
            { id: 2, title: "Compatibility", content: "Windows, Mac, Linux" },
            { id: 3, title: "Power", content: "Self-powered" },
            { id: 4, title: "Design", content: "Compact & Portable" }
        ],
        comments: [
            {
                id: 1,
                image: images.product15Review1,
                name: "Emma Wilson",
                date: "Mar 10, 2025",
                rating: 4.4,
                content: "Convenient and reliable USB hub with plenty of ports for all my devices."
            },
            {
                id: 2,
                image: images.product15Review2,
                name: "Noah Davis",
                date: "Mar 12, 2025",
                rating: 4.5,
                content: "Great build quality and fast data transfer speeds."
            }
        ]
    }

];

export default products;